/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/confetti_medium'
export default icon
